<template>
  <div class="mask" v-show="show" @click.self="clickPopup">
    <div class="popup" id="popWindow">
      <h1>{{ title }}</h1>
      <div class="text">{{ message }}</div>
      <div class="choice">
        <div @click="clickPopup">confirm</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "selectpopup",
  props:['title', 'message','show'],
  methods:{
    clickPopup(){
      this.$emit('closePopup')
    }
  },
};
</script>

<style scoped lang='less'>
.mask{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  // height: 100vh;
  width: 100%;
  background: rgba(0, 0, 0, 0.46);
  .popup{
    width: 4.666667rem * 2;
    // height: 2.24rem * 2;
    background: #FFFFFF;
    border-radius: .08rem * 2;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    padding: .266667rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    h1{
      font-size: .24rem * 2;
      color: #222328;
      line-height: .666667rem;
      font-weight: bold;
    }
    .text{
      line-height: .586667rem;
      font-size: .213333rem * 2;
      text-align: left;
    }
    .choice{
      display: flex;
      justify-content: space-between;
      div{
        width: 100%;
        line-height: .586667rem * 2;
        border-radius: .16rem;
        color: #FFFFFF;
        font-weight: bold;
        font-size: .533333rem;
        &:first-child{
          background: #A1A6BA;
        }
        &:last-child{
          background: #9D6C29;
        }
      }
    }
  }
}
</style>
